var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "station" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("access.settemplate"),
            visible: _vm.dialogTemplate,
            width: "450px",
            modal: true,
            "before-close": _vm.cancelTemplate,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTemplate = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.info,
                rules: _vm.rules,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.$t("access.templatename")) + "："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.info.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.info, "name", $$v)
                      },
                      expression: "info.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "info" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.$t("access.templatecontent")) + "："),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.info.info,
                      callback: function ($$v) {
                        _vm.$set(_vm.info, "info", $$v)
                      },
                      expression: "info.info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.cancelTemplate } }, [
                _vm._v(_vm._s(_vm.$t("public.cancel"))),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }